module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Outgoing-call-25839af1bbcaab8d49fb896be2291ce5.svg";